module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"place":"Place","point":"Point"}},"ja":{"label":{"place":"順位","point":"点数","win":"勝","lose":"敗","draw":"分"}}}')
  delete Component.options._Ctor
}
